import type { Validator } from 'prop-types';

// A useful utility for combining custom prop types with React's propTypes
// Let's pretend you have a prop type that requires extra check from a custom prop type function
// but is also a string PropTypes, you can type it as
// someStringProp: combinePropTypes(PropTypes.string, myCustomPropTypeChecker)
export const combinePropTypes =
  <T>(...validators: Validator<T>[]): Validator<T> =>
  (...args) => {
    for (const validator of validators) {
      const result = validator(...args);
      if (result instanceof Error) {
        return result;
      }
    }
    return null;
  };
